import React, {Component} from 'react';
import _ from 'lodash';
import '../styles/Data.css';
import { getDashboard } from '../services/dashboardService';


class Data extends Component {
  constructor(props) {
    super(props);
    this.state = {data: this.getData()};
  }

  componentDidMount() {
    this.setStateInterval = window.setInterval(() => {
      this.setState({data: this.getData()});
    }, 4000);
    this._isMounted = true;
    this.fetchStories();

  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  getData() {
    return _.range(7).map(() => {
      return [
        {x: 1, y: _.random(1, 5)},
        {x: 2, y: _.random(1, 10)},
        {x: 3, y: _.random(2, 10)},
        {x: 4, y: _.random(2, 10)},
        {x: 5, y: _.random(2, 15)},
      ];
    });
  }

  //queries GET

  fetchStories = () => {
    this.setState({isLoading: true});
    getDashboard()
      .then(result => (this._isMounted) ? this.onSetResult(result) : '')
      .catch(() => {});
  };

  onSetResult = function (result) {

    this.setState(result);


  };


  render() {
    return (
      <div className="datadiv">
        <div className="row  ">
          <div className="col-md-3 stretch-card grid-margin">
            <div className="card p-3 mb-2 bg-primary text-white">

              <h4 className="font-weight-normal mb-3">Utilisateurs
              </h4>
              <h2 className="mb-3">{new Intl.NumberFormat('fr-FR').format(parseInt(this.state.users, 10))}</h2>
            </div>
          </div>

          <div className="col-md-3 stretch-card grid-margin">
            <div className="card p-3 mb-2 bg-warning text-dark">

              <h4 className="font-weight-normal mb-3">Communauté
              </h4>
              <h2 className="mb-3">{new Intl.NumberFormat('fr-FR').format(parseInt(this.state.websites, 10))}</h2>

            </div>
          </div>


          <div className="col-md-3 stretch-card grid-margin">
            <div className="card p-3 mb-2 bg-danger text-white">

              <h4 className="font-weight-normal mb-3">Pages GC
              </h4>
              <h2 className="mb-3"> {new Intl.NumberFormat('fr-FR').format(parseInt(this.state.threads, 10))}</h2>


            </div>
          </div>
          <div className="col-md-3 stretch-card grid-margin">
            <div className="card p-3 mb-2 bg-success text-white">

              <h4 className="font-weight-normal mb-3">Commentaires
              </h4>
              <h2 className="mb-3">{new Intl.NumberFormat('fr-FR').format(parseInt(this.state.comments, 10))}</h2>
            </div>
          </div>

          <div className="col-md-3 stretch-card grid-margin">
            <div className="card p-3 mb-2 bg-secondary text-white">

              <h4 className="font-weight-normal mb-3">Votes
              </h4>
              <h2 className="mb-3">{new Intl.NumberFormat('fr-FR').format(parseInt(this.state.votes, 10))}</h2>
            </div>
          </div>

          <div className="col-md-3 stretch-card grid-margin">
            <div className="card p-3 mb-2 bg-dark text-white">

              <h4 className="font-weight-normal mb-3">Profils
              </h4>
              <h2 className="mb-3">{new Intl.NumberFormat('fr-FR').format(parseInt(this.state.profiles, 10))}</h2>
            </div>
          </div>


          <div className="col-md-3 stretch-card grid-margin">
            <div className="card p-2 mb-1 bg-info text-white">
              <h4 className="font-weight-normal mb-3">Vues
              </h4>
              <h2 className="mb-3">{new Intl.NumberFormat('fr-FR').format(parseInt(this.state.views, 10))}</h2>
            </div>
          </div>
      
  
        <div className="col-md-3 stretch-card grid-margin">
          <div className=" card p-2 mb-1 -white .text-light">
            <h4 className="font-weight-normal mb-3">Pages
            </h4>
            <h2 className="mb-3">{new Intl.NumberFormat('fr-FR').format(parseInt(this.state.pages, 10))}</h2>
          </div>
        </div>
      </div>

      </div>
      


    )
  }


}


export default Data;

